module.exports = __webpack_public_path__ + "img/image11.73f36ef6.jpg";